// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_draftProperty_price(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DraftPropertyExactPrice",
    "DraftPropertyPriceRange"
  ]);
}

function unwrap_fragment_draftProperty_propertyData(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DraftPropertyDataForSaleV5",
    "DraftPropertyDataRentalV5"
  ]);
}

let fragmentConverter = {"__root":{"draftProperty_showings_date":{"b":""},"draftProperty_propertyData_DraftPropertyDataRentalV5_availableFrom":{"b":""},"draftProperty_propertyData":{"u":"fragment_draftProperty_propertyData"},"draftProperty_price":{"u":"fragment_draftProperty_price"},"draftProperty_onMlsAt":{"b":""},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_draftProperty_price: unwrap_fragment_draftProperty_price,
  fragment_draftProperty_propertyData: unwrap_fragment_draftProperty_propertyData
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function draftV5Status_decode($$enum) {
  if ($$enum === "DELETED" || $$enum === "RESUMABLE_DRAFT" || $$enum === "DRAFT" || $$enum === "PUBLISHED" || $$enum === "EXPIRED") {
    return $$enum;
  }
}

let draftV5Status_fromString = draftV5Status_decode;

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function leaseLengthValue_decode($$enum) {
  if ($$enum === "LONG" || $$enum === "SHORT_OR_LONG" || $$enum === "SHORT") {
    return $$enum;
  }
}

let leaseLengthValue_fromString = leaseLengthValue_decode;

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

function onOrOffV5_decode($$enum) {
  if ($$enum === "OFF" || $$enum === "ON") {
    return $$enum;
  }
}

let onOrOffV5_fromString = onOrOffV5_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

let Utils = {
  draftV5Status_decode: draftV5Status_decode,
  draftV5Status_fromString: draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: leaseLengthValue_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  onOrOffV5_decode: onOrOffV5_decode,
  onOrOffV5_fromString: onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewPropertyPageRelayFormData_serverDraft",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayPreview_serverDraft"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChapterV5",
      "kind": "LinkedField",
      "name": "chapter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ChapterPreferencesV5",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mlsComingSoon",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DraftPropertyV5",
      "kind": "LinkedField",
      "name": "draftProperty",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "anonymousProperty",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "goingOnMls",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "willAcceptOffers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "willShow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mlsListingType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onMlsAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DraftPropertyV5GeocodingData",
          "kind": "LinkedField",
          "name": "geocodingData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lat",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lon",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "standardizedAddress",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "standardizedCity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "standardizedState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "standardizedZip",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FileAttachment",
          "kind": "LinkedField",
          "name": "files",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "width",
                  "value": 300
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(width:300)"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DraftShowingV5",
          "kind": "LinkedField",
          "name": "showings",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTime",
              "storageKey": null
            },
            {
              "alias": "typ",
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "displayNeighborhood",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "userSelectedArea",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hideAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Price",
                  "kind": "LinkedField",
                  "name": "price",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "DraftPropertyExactPrice",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Price",
                  "kind": "LinkedField",
                  "name": "maxPrice",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Price",
                  "kind": "LinkedField",
                  "name": "minPrice",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "DraftPropertyPriceRange",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "propertyData",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "forSalePropertyType",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "propertyType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "commission",
                  "storageKey": null
                }
              ],
              "type": "DraftPropertyDataForSaleV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "rentalPropertyType",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "propertyType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableFrom",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LeaseLengthV5",
                  "kind": "LinkedField",
                  "name": "leaseLength",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "DraftPropertyDataRentalV5",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baths",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "beds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "halfBaths",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "livingArea",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lotSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfUnits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parkingSpaces",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parkingDetails",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DraftV5",
  "abstractKey": null
};
})());

let wrap_fragment_draftProperty_price = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_draftProperty_propertyData = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_draftProperty_price = unwrap_fragment_draftProperty_price;
exports.wrap_fragment_draftProperty_price = wrap_fragment_draftProperty_price;
exports.unwrap_fragment_draftProperty_propertyData = unwrap_fragment_draftProperty_propertyData;
exports.wrap_fragment_draftProperty_propertyData = wrap_fragment_draftProperty_propertyData;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
